import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useTheme, Box, AHTag } from "arkh";
import React from "react";
import { TouchableOpacity } from "react-native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TopicSelector_orgTopic$key } from "./__generated__/TopicSelector_orgTopic.graphql";

export function TopicSelector(props: {
  topics: TopicSelector_orgTopic$key;
  currentTopicId?: string;
  onTopicSelect: (topicId: string | undefined) => void;
}) {
  const topics = useFragment(
    graphql`
      fragment TopicSelector_orgTopic on OrgTopic @relay(plural: true) {
        id
        name
        isPrivate
      }
    `,
    props.topics
  );
  const theme = useTheme();
  const title = useIntlTokens();

  return (
    <Box
      space="small"
      gap="small"
      color="surface"
      borderColor="border-primary"
      style={{ flexDirection: "row", flexWrap: "wrap", borderBottomWidth: 1 }}
    >
      <TouchableOpacity
        onPress={() => {
          props.onTopicSelect(undefined);
        }}
      >
        <AHTag
          title={title.AllUnitsAndTeams}
          color={theme.primary}
          selected={props.currentTopicId === undefined}
        />
      </TouchableOpacity>
      {topics.map((topic) => (
        <TouchableOpacity
          key={topic.name}
          onPress={() => {
            props.onTopicSelect(topic.id);
          }}
        >
          <AHTag
            title={topic.name}
            color={theme.primary}
            selected={props.currentTopicId === topic.id}
          />
        </TouchableOpacity>
      ))}
    </Box>
  );
}
